import { Component, OnInit, Input } from '@angular/core';
import { Tab } from 'src/app/core/interfaces';

@Component({
  selector: 'app-tabset',
  templateUrl: './tabset.component.html',
  styleUrls: ['./tabset.component.less'],
})
export class TabsetComponent implements OnInit {
  @Input() tabs: Tab[];
  @Input() routing? = false;

  constructor() {}

  ngOnInit(): void {}
}
